<template>
  <a class="skip" href="#main">{{ t("Aller au contenu", "Skip to content") }}</a>
  <TopoBackground />
  <div class="shell">
    <SiteHeader />
    <main id="main">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "./components/Header.vue";
import SiteFooter from "./components/Footer.vue";
import TopoBackground from "./components/TopoBackground.vue";
import { useI18n } from "./i18n";

export default {
  name: "App",
  components: { SiteHeader, SiteFooter, TopoBackground },
  setup() {
    return useI18n();
  },
};
</script>
